import React from 'react';

export default function RecentSearches({ items, onSelect, onClear }) {
  if (!items?.length) return null;

  return (
    <section className="recent-searches" aria-label="ค้นหาล่าสุด">
      <div className="recent-searches__header">
        <p className="recent-searches__label">ค้นหาล่าสุดของคุณ</p>
        <button type="button" className="recent-searches__clear" onClick={onClear}>
          ล้าง
        </button>
      </div>
      <div className="recent-searches__list">
        {items.map((item) => (
          <button
            key={item}
            type="button"
            className="recent-searches__chip"
            onClick={() => onSelect(item)}
          >
            {item}
          </button>
        ))}
      </div>
    </section>
  );
}
